import {
  FormControlLabel,
  FormGroup,
  FormHelperText,
  Switch,
  SwitchProps,
  SxProps,
} from '@mui/material';
import { Controller } from 'react-hook-form';

interface ICheckBoxFieldProps {
  name: string;
  control: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  label: string | React.ReactNode;
  defaultChecked?: boolean;
  sx?: SxProps;
  formGroupSx?: SxProps;
  disabled?: boolean;
  inputLabel?: string;
  color?: SwitchProps['color'];
  // customize incoming value to render
  renderValue?: (fieldValue: any, formValue?: any) => any; //eslint-disable-line @typescript-eslint/no-explicit-any
  // customize value before submission
  customizeValue?: (checked: any, value?: any) => any; //eslint-disable-line @typescript-eslint/no-explicit-any
  value?: any; //eslint-disable-line @typescript-eslint/no-explicit-any
}

export function RHFSwitchbox({
  name,
  control,
  label,
  formGroupSx,
  disabled = false,
  renderValue,
  customizeValue,
  value,
  ...rest
}: ICheckBoxFieldProps) {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormGroup sx={formGroupSx}>
            <FormControlLabel
              label={label}
              control={
                <Switch
                  checked={
                    (renderValue
                      ? renderValue(field.value, value)
                      : field.value) || false
                  }
                  onChange={(e) => {
                    // customize value before submission if provided
                    if (customizeValue) {
                      return field.onChange(
                        customizeValue(e.target.checked, e.target.value),
                      );
                    } else {
                      return field.onChange(e.target.checked);
                    }
                  }}
                  value={value}
                  disabled={disabled}
                  {...rest}
                />
              }
            />
            <FormHelperText error={true}>
              {error ? error?.message : ''}
            </FormHelperText>
          </FormGroup>
        </>
      )}
    />
  );
}
